/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Merge_Change_TargetInputs */



/**
* | output |
* | --- |
* | "Change" |
*
* @param {Vekn_Merge_Change_TargetInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merge_change_target = /** @type {((inputs?: Vekn_Merge_Change_TargetInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Merge_Change_TargetInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Changer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cambia")
	return /** @type {LocalizedString} */ ("Change")
});